export default "__VITE_ASSET__DZOYGCqM__"